const POST_CREDIT_SERVICE_PENDING: string = 'POST_CREDIT_SERVICE_PENDING'
const POST_CREDIT_SERVICE_SUCCESS: string = 'POST_CREDIT_SERVICE_SUCCESS'
const POST_CREDIT_SERVICE_ERROR: string = 'POST_CREDIT_SERVICE_ERROR'
const POST_CREDIT_SERVICE_INIT: string = 'POST_CREDIT_SERVICE_INIT'

export { POST_CREDIT_SERVICE_PENDING, POST_CREDIT_SERVICE_SUCCESS, POST_CREDIT_SERVICE_ERROR, POST_CREDIT_SERVICE_INIT }